module.exports = __webpack_public_path__ + "static/media/Quick Start Guide.8f206966.pdf";